"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ComponentError", {
  enumerable: true,
  get: function get() {
    return _ComponentError.default;
  }
});
exports.default = void 0;

var _ComponentError = _interopRequireDefault(require("./ComponentError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Don't export any default exports
var _default = {};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/internal/index.js
// module id = 672
// module chunks = 0 15 16 17 18